import React, { Component } from "react";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { utcToLocal } from "../../utils/dateConvert";

class GroupTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sortString: "customer",
      sortDirection: "asc",
    };
    this.sortStringName = "customer";
    this.sortDirection = "asc";
  }

  handleSortString = (name) => {
    this.setState({
      sortString: name,
      sortDirection: "asc",
    });
    this.sortStringName = name;
    this.sortDirection = "asc";
    this.callback(name, this.sortDirection);
  };
  handleSortDirection = () => {
    if (this.state.sortDirection == "asc") {
      this.setState({
        sortDirection: "des",
      });
      this.sortDirection = "des";
    } else {
      this.setState({
        sortDirection: "asc",
      });
      this.sortDirection = "asc";
    }
    this.callback(this.sortStringName, this.sortDirection);
  };

  callback = (name, order) => {
    this.props.sortFunction(name, order);
  };

  render() {
    return (
      <div>
        <Table responsive striped>
          <thead>
            <tr>
              <th>
                Name
                {this.state.sortString == "name" ? (
                  <i
                    onClick={this.handleSortDirection}
                    className={`fa ${this.state.sortDirection == "asc"
                        ? "fa-sort-amount-asc"
                        : "fa-sort-amount-desc"
                      }`}
                  />
                ) : (
                  <i
                    className="fa fa-exchange"
                    onClick={() => {
                      this.handleSortString("name");
                    }}
                  />
                )}
              </th>
              <th>Description</th>
              <th style={{ minWidth: "120px" }}>
                Customer{" "}
                {this.state.sortString == "customer" ? (
                  <i
                    onClick={this.handleSortDirection}
                    className={`fa ${this.state.sortDirection == "asc"
                        ? "fa-sort-amount-asc"
                        : "fa-sort-amount-desc"
                      }`}
                  />
                ) : (
                  <i
                    className="fa fa-exchange"
                    onClick={() => {
                      this.handleSortString("customer");
                    }}
                  />
                )}
              </th>
              <th>Icon</th>
              <th>Is Default</th>
              <th>Sequence</th>

              <th style={{ minWidth: "80px" }}>
                Status
                {this.state.sortString == "status" ? (
                  <i
                    onClick={this.handleSortDirection}
                    className={`fa ${this.state.sortDirection == "asc"
                        ? "fa-sort-amount-asc"
                        : "fa-sort-amount-desc"
                      }`}
                  />
                ) : (
                  <i
                    className="fa fa-exchange"
                    onClick={() => {
                      this.handleSortString("status");
                    }}
                  />
                )}
              </th>
              <th style={{ minWidth: "100px" }}>
                Updated
                {this.state.sortString == "updated" ? (
                  <i
                    onClick={this.handleSortDirection}
                    className={`fa ${this.state.sortDirection == "asc"
                        ? "fa-sort-amount-asc"
                        : "fa-sort-amount-desc"
                      }`}
                  />
                ) : (
                  <i
                    className="fa fa-exchange"
                    onClick={() => {
                      this.handleSortString("updated");
                    }}
                  />
                )}
              </th>
              <th style={{ width: "200px" }}></th>
            </tr>
          </thead>
          <tbody>
            {this.props.GroupList.map((groups, index) => {
              return (
                <tr>
                  <td>{groups.name}</td>
                  <td>{groups.description}</td>
                  <a
                    onClick={() =>
                      localStorage.setItem(
                        "customer",
                        JSON.stringify({
                          customerId: groups.customerId,
                          customerName: groups.customerName,
                        })
                      )
                    }
                    href={`/groups?customerId=${groups.customerId}&customerName=${groups.customerName}`}
                  >
                    <td>{groups.customerName}</td>
                  </a>

                  <td>
                    <i
                      style={{ color: `${groups.colour}` }}
                      className={groups.icon}
                    ></i>
                  </td>
                  <td>
                    {groups.menuDefault == 0 ? (
                      <input
                        type="checkbox"
                        style={{ pointerEvents: "none" }}
                      />
                    ) : (
                      <input
                        type="checkbox"
                        checked
                        style={{ pointerEvents: "none" }}
                      />
                    )}
                  </td>
                  <td>{groups.menuPriority}</td>
                  <td>{groups.status}</td>
                  <td>
                    {groups.dbUpdated ? utcToLocal(groups.dbUpdated) : ""}
                  </td>
                  <td>
                    <Link to={`/editGroup/${groups.id}`}>Edit</Link> |{" "}
                    <Link to={`/groupDetails/${groups.id}`}>Details</Link> |{" "}
                    <Link to={`/deleteGroup/${groups.id}`}>Delete</Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default GroupTable;
